;(function ($) {
    var pluginName = 'rkasForeginLink';
    var defaults = {};
    var initSelector = 'a[target=_blank]:not(.button)';


    function ForeginLink($elements, options) {
        this.$element = $elements;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }


    ForeginLink.prototype.init = function () {
        // console.log(this.$element);
        this.$icon = $(rkas.icon.render('#exit-right', "icon--text-middle icon--right icon--left"));
        // this.test = $('<a href="#" data-toggle="collapse" class="collapse__close">' + rkas.icon.render('#close-round') + '</a>');
        $(this.$element).append(this.$icon);
        // this.$element.html(this.test);
    };

    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Button(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };


    /**
     * Create jQuery plugin.
     * @param {Object} options Extended options
     * @listens rkas.ForeginLink
     * @returns {Array<ForeginLink>} Array of ForeginLinks
     */
    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new ForeginLink(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }


        });

    };

    /**
     * @event enhance.rkas.equalHeight
     * @param   {Event} event
     */
    $(document).on('enhance.rkas.equalHeight', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @event destroy.rkas.equalHeight
     * @param   {Event} event
     */
    $(document).on('destroy.rkas.equalHeight', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.rkas.foreginLink
     */
    $(function () {
        $(document).trigger('enhance.rkas.foreginLink');
    });
}(jQuery));

/**
 * Check if element is visible.
 *
 * @param  {number} threshold - Threshold to add to element position.
 * @returns {boolean} - Is on screen or not.
 */
;(function ($) {
    $.fn.isOnScreen = function (threshold) {
        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();

        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top + threshold || viewport.top > bounds.bottom));
    };
}(jQuery));

function preventEmpy(id) {
    var val = $("#" + id).val();
    if (val.length > 0 && val !== undefined) {
        return true;
    }
    return false;
}
